// extracted by mini-css-extract-plugin
export default {"featureToggle":"feature_toggle_featureToggle__iMcOT","toggleOn":"feature_toggle_toggleOn__7FoO2"};